<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-11-02 15:30:44
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-15 19:52:55
 * @FilePath: \seller.sviptrader.com\src\views\teamManage\accountManage\components\handoverDrawer\tobeHanded\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="mt-8">
		<div class="top flex-row-align-center font-h4-regular">
			<div class="mr-32"> 已移交 </div>
			<div class="yx-color-text-primary ml-8">
				<span>达人数：</span>
				<span class="yx-color-primary">{{ relaycountObj.anchor_count }}</span>
				<span class="ml-24">团长数：</span>
				<span class="yx-color-primary">{{ relaycountObj.institution_count }}</span>
				<span class="ml-24">商品数：</span>
				<span class="yx-color-primary">{{ relaycountObj.product_count }}</span>
			</div>
		</div>
		<div class="table mt-24 gray-table-header">
			<multi-table
				:stickyHeader="false"
				v-loading="loading"
				ref="multiTable"
				:columns="columns"
				@gePartnerList="gePartnerList"
				:list="list"
				:page="pageInfo"
				:total="total"
			>
				<empty slot="empty">
					<div slot="desc">暂无数据</div>
				</empty>
			</multi-table>
		</div>
	</div>
</template>
<script>
import { relayList, relaycount } from '@/api/teamManage';
import columns from './columns';
import empty from '@/views/common/empty/index.vue';
export default {
	props: {
		user_id: {
			type: String,
			default: '',
		},
	},
	components: {
		empty,
	},
	data() {
		return {
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			total: 0,
			selectList: [],
			list: [],
			relaycountObj: {},
			columns,
			loading: false,
		};
	},
	methods: {
		init() {
			this.pageInfo = {
				page_index: 1,
				page_size: 10,
			};
			this.getList();
			this.relaycount();
		},
		async getList() {
			const { user_id: from_user_id } = this;
			this.loading = true;
			try {
				const {
					list = [],
					page: { item_total },
				} = await relayList({ from_user_id, ...this.pageInfo });
				this.list = list.map(item => {
					return {
						...item,
						operations:
							item.task_type == 'task_type_product'
								? []
								: [
										{
											label: '详情',
											type: 'text',
											click: this.seeDetails,
										},
								  ],
					};
				});

				this.total = item_total;
				this.loading = false;
			} catch (e) {
				this.loading = false;
			}
		},
		async relaycount() {
			const { user_id: from_user_id } = this;
			const data = await relaycount({ from_user_id });
			this.relaycountObj = data;
		},
		seeDetails(row) {
			this.$emit('seeDetails', row);
		},
		gePartnerList(val) {
			this.pageInfo.page_index = val.page_index;
			this.pageInfo.page_size = val.page_size;
			this.getList();
		},
	},
};
</script>
<style lang="less" scoped></style>
